module.exports = __webpack_public_path__ + "static/hero-img-17db9e4cc987fc387e0ea9f9c2848b98.svg";